import React from 'react';
import PropTypes from 'prop-types';
import MuiDialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/styles';
import ArrowBackwardButton from 'components/ArrowBackwardButton';
import SecondaryContainedButton from 'components/SecondaryContainedButton';
import { useQuestionnaireData } from '../context';

const BACK_SECTION_HEIGHT = 48;
const NEXT_BUTTON_SECTION_MARGIN_TOP = 8;
const NEXT_BUTTON_SECTION_HEIGHT = 48;

const useStyles = makeStyles(() => ({
  backSection: {
    display: 'flex',
    alignItems: 'center',
    height: BACK_SECTION_HEIGHT,
    backgroundColor: '#f6f3ef',
  },
  content: {
    maxWidth: '100%',
    height: `calc(100% - ${BACK_SECTION_HEIGHT}px)`,
    overflow: 'hidden',
  },
  questionInputSection: {
    maxWidth: '100%',
    maxHeight: ({ nextButtonSectionIsShown }) => (
      nextButtonSectionIsShown
        ? `calc(100% - ${NEXT_BUTTON_SECTION_MARGIN_TOP}px - ${NEXT_BUTTON_SECTION_HEIGHT}px)`
        : '100%'
    ),
    flexGrow: 12,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  nextButtonSection: {
    flexShrink: 0,
    height: NEXT_BUTTON_SECTION_HEIGHT,
    marginTop: ({ embedded }) => (embedded ? '-10px' : NEXT_BUTTON_SECTION_MARGIN_TOP),
  },
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export const FullScreenQuestionInput = ({
  handleBack, children, shouldNextButtonBeShown, handleNext,
}) => {
  const { embedded } = useQuestionnaireData();
  const classes = useStyles({ nextButtonSectionIsShown: shouldNextButtonBeShown, embedded });

  return (
    <MuiDialog
      fullScreen
      disableScrollLock
      open
      onClose={handleBack}
      scroll="paper"
      TransitionComponent={Transition}
    >
      <div className={classes.backSection}>
        <ArrowBackwardButton
          label="questionnaire.button.back"
          onClick={handleBack}
        />
      </div>
      <DialogContent className={classes.content}>
        <div className={classes.questionInputSection}>
          {children}
        </div>
        {shouldNextButtonBeShown && (
          <div className={classes.nextButtonSection}>
            <SecondaryContainedButton
              onClick={handleNext}
              label="button.next.label"
            />
          </div>
        )}
      </DialogContent>
    </MuiDialog>
  );
};

FullScreenQuestionInput.propTypes = {
  children: PropTypes.node.isRequired,
  handleBack: PropTypes.func.isRequired,
  shouldNextButtonBeShown: PropTypes.bool.isRequired,
  handleNext: PropTypes.func.isRequired,
};
